import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  updateTeamFields(e) {
    const selectorToDisable = e.target.dataset["selectorToDisable"];
    const elToDisable = document.querySelector(selectorToDisable);

    const selectorToClear = e.target.dataset["selectorToClear"];
    const parentContainerToClear = document.querySelector(selectorToClear);
    const fieldsToClear = parentContainerToClear.querySelectorAll('input[type="date"], input[type="text"]');

    const selectorToRequire = e.target.dataset["selector"];
    const parentContainerToRequire = document.querySelector(selectorToRequire);
    const fields = parentContainerToRequire.querySelectorAll('input[type="date"], input[type="text"]');

    if (e.target.checked) {
      fieldsToClear.forEach(field => {
        field.value = '';
      });
      elToDisable.setAttribute('disabled', true);

      fields.forEach(field => {
        field.required = true;
      });
    } else {
      elToDisable.removeAttribute('disabled');

      fields.forEach(field => {
        field.removeAttribute('required');
        field.value = '';
      });
    }
  }
}
